import styled from "styled-components";

export const WhoWeAreCompWrapper = styled.div`
  .who_we_are_row {
    align-items: stretch;
    margin: -15px;
    .col_cmn {
      padding: 15px;
    }
    .col_left {
      width: calc(100% - 52%);
      @media (max-width: 1199px) {
        width: 100%;
      }
      .who_we_are_heading {
        width: 100%;
        padding-top: 75px;
        @media (max-width: 1440px) {
          max-width: 504px;
        }
        @media (max-width: 1199px) {
          max-width: 100%;
          padding-top: 0;
        }
      }
    }
    .col_right {
      width: 52%;
        @media (max-width: 1199px) {
        width: 100%;
      }
    }
  }
`;
